import angular from 'angular';
import { isNil } from 'lodash';

module.exports = angular.module('common.filters.pretty', [])
.filter('pretty', function() {
  return function(value) {
    if (!isNil(value))
      return String(value).replace(/_/g, ' ');
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/pretty.js
 **/